import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import { Alert, Grid, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import download from "downloadjs";
import ViewDocument from "../modals/view-documents/ViewDocument";
import SimpleCard from "../../../../../../shared/components/SimpleCard";
import { useCallback, useMemo } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import useUserIs from "@/src-refactor/modules/shared/hooks/use-useris.hook";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import DoDisturbAltRoundedIcon from "@mui/icons-material/DoDisturbAltRounded";

import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import useModal from "@/src-refactor/modules/shared/components/refactor/base/modal/useModal";
import OppositionCommendToDocumentsTemplate from "./OpositionCommenToDocuments";
import useAlert from "@/src-refactor/modules/shared/components/refactor/hooks/useAlert";
import MxPopover from "../../../../../../shared/components/refactor/components/l1/MxPopover";
import { useApproveDocumentMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import MxTypography from "@rf-l1/MxTypography";
import {
  IconCloudDownload,
  IconEye,
  IconFileImport,
  IconFiles
} from "@tabler/icons-react";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import dayjs from "dayjs";
import useDownloadDocument from "@/src-refactor/modules/shared/hooks/useDowloadFile";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";

const ValidationDocuments = () => {
  const [APPROVE_M] = useApproveDocumentMutation();
  const { downloadDocument } = useDownloadDocument();
  const { modal } = useModal();
  const { alert } = useAlert();
  const { guardReadOnlyAction } = useReadOnlyModeGuard();

  const handleSendComment = (document: string, id: number) => {
    guardReadOnlyAction("rechazar documento", "legacy-validation-documents");
  };

  const handleApproveDocument = (id: number) => {
    guardReadOnlyAction("aprobar documento", "legacy-validation-documents");
  };

  const isMonitorBig = useMediaQuery("(min-width:2560px)");
  const isMonitor = useMediaQuery("(min-width:1440px) and (max-width:1919px)");
  const isLaptop = useMediaQuery("(min-width:1024px) and (max-width:1439px)");

  const getTruncateLength = () => {
    if (isMonitorBig) return 34;
    if (isMonitor) return 22;
    if (isLaptop) return 24;
    return 20;
  };

  const {
    PROPERTY_DETAIL: {
      validationDocuments,
      validationDocumentsAlerts,
      principalData,
      agents
    }
  } = useRealEstateDetailContext();

  const { userIs, userLogged } = useUserIs();

  const isSUPER_ADMIN = userIs(ERolesCode.SUPER_ADMIN);
  const hidden = useMemo(() => {
    if (!principalData.is_project) {
      return true;
    }

    if (
      userLogged.userData?.email == "gracielamarte@remaxm.net" ||
      userIs(ERolesCode.SUPER_ADMIN) ||
      agents.some(x => x.id == userLogged.userData?.people_id)
    ) {
      return false;
    }
    return true;
  }, [
    validationDocuments,
    validationDocumentsAlerts,
    agents,
    userLogged,
    isSUPER_ADMIN,
    principalData.is_project
  ]);

  if (hidden) {
    return <></>;
  }

  const enCodeUrl = useCallback((url: string) => {
    const extension = url.split(".").pop();
    return extension;
  }, []);

  // const downloadDocument = async (url: string, name: string) => {
  //   try {
  //     const newName = `${name}-${principalData.id}.${enCodeUrl(url)}`;
  //     const response = await axios.get(url, { responseType: "blob" });
  //     const newBlob = new Blob([response.data], {
  //       type: response.headers["content-type"]
  //     });
  //     download(newBlob, newName);
  //     toast.success("Documento descargado satisfactoriamente.");
  //   } catch (error) {
  //     toast.error("Error al descargar el archivo, intente nuevamente.");
  //   }
  // };

  const onOpenInOtherWindow = (url: string) => {
    if (!url) return;
    window.open(url, "_blank");
  };

  return (
    <SimpleCard showBg={false} title="Documentos validación de proyecto">
      <Grid
        container
        spacing={0.5}
        sx={{
          marginTop: "-1rem",
          paddingBottom: "1.1rem",
          display: "flex"
        }}
      >
        <Grid item xs={12}>
          {validationDocumentsAlerts
            .filter(item => item.message !== "")
            .map(document => (
              <Alert
                key={document.id}
                severity={document.isExpired ? "error" : "warning"}
                sx={{ marginBottom: 1 }}
              >
                <MxTypography
                  variant="overline"
                  color={document.isExpired ? "error.main" : "warning.main"}
                  fontWeight={500}
                >
                  {document.message}
                </MxTypography>
              </Alert>
            ))}
        </Grid>

        {validationDocuments.map(document => (
          <Grid
            key={document.id}
            container
            xs={12}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs="auto">
              <Tooltip title="Descargar documento">
                <Button
                  size="small"
                  className="--blue"
                  onClick={() => downloadDocument(document.url, document.name)}
                >
                  <IconCloudDownload />
                </Button>
              </Tooltip>
            </Grid>

            <Grid item xs="auto">
              <ViewDocument
                Button={
                  <Tooltip title="Ver documento">
                    <Button size="small" className="--blue">
                      <IconEye />
                    </Button>
                  </Tooltip>
                }
                url={document.url}
                dateMsg={
                  document.dateExpedition
                    ? `Fecha de emisión ${dayjs(document.dateExpedition).format(
                        "DD-MM-YYYY"
                      )}`
                    : "-"
                }
              />
            </Grid>

            <Grid item xs="auto">
              <Tooltip title="Abrir documento en otra pestaña">
                <Button
                  className="--blue"
                  onClick={() => onOpenInOtherWindow(document.url)}
                  size="small"
                >
                  <IconFiles />
                </Button>
              </Tooltip>
            </Grid>

            <Tooltip title={document.name}>
              <Grid item xs="auto">
                <MxTypography
                  variant="body2"
                  color="primary.main"
                  fontWeight="400"
                  lines={1}
                >
                  {document.name}
                </MxTypography>
              </Grid>
            </Tooltip>

            <Grid flex={1} />

            <Grid container item xs="auto">
              <Grid item xs="auto">
                {document.message_alert && !document.status.approved && (
                  <Tooltip title={document.message_alert}>
                    <MxPopover message={document.message_alert ?? ""}>
                      <Button size="small" className="--yellow">
                        <WarningAmberRoundedIcon />
                      </Button>
                    </MxPopover>
                  </Tooltip>
                )}
              </Grid>

              <Grid item xs="auto">
                {document.status_comment && document.status.rejected && (
                  <MxPopover message={document.status_comment}>
                    <Button size="small" className="--blue">
                      <MessageOutlinedIcon />
                    </Button>
                  </MxPopover>
                )}
              </Grid>

              <Grid item xs="auto">
                {document.status.pending && isSUPER_ADMIN && (
                  <Tooltip title="Aprobar documento">
                    <Button
                      className="--green"
                      onClick={() => handleApproveDocument(document.id)}
                      size="small"
                    >
                      <CheckCircleRoundedIcon />
                    </Button>
                  </Tooltip>
                )}
              </Grid>

              <Grid item xs="auto">
                {document.status.pending && isSUPER_ADMIN && (
                  <Tooltip title="Rechazar documento">
                    <Button
                      className="--red"
                      onClick={() => handleSendComment(document.name, document.id)}
                      size="small"
                    >
                      <DoDisturbAltRoundedIcon />
                    </Button>
                  </Tooltip>
                )}
              </Grid>

              <Grid item xs="auto">
                {document.status.approved && (
                  <TextSimple color="green" size="small" font="inter" weight="400">
                    Aprobado
                  </TextSimple>
                )}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </SimpleCard>
  );
};

export default ValidationDocuments;

const Button = styled(IconButton)`
  & svg {
    width: 16px;
    height: 16px;
  }

  &.--blue {
    fill: var(--m-color-blue-03);
    color: var(--m-color-blue-03);
  }
  &.--green {
    fill: var(--m-color-green-01);
    color: var(--m-color-green-01);
  }
  &.--red {
    fill: var(--m-color-red-01);
    color: var(--m-color-red-01);
  }
  &.--yellow {
    fill: #ffae1a;
    color: #ffae1a;
  }
`;
